import { memoize } from 'lodash'
import { stateCodeToName } from '../../../util/states'

// States
const memoizedStates = memoize(stateCodeToName) // To avoid multiple function call
const getStateOptions = () => {
  const statesCodes = memoizedStates()
  const statesOptions = []
  let i = 0
  for (const key in statesCodes) {
    statesOptions[i++] = { key, value: key, text: statesCodes[key] }
  }
  return statesOptions
}

export const STATE_OPTIONS = [
  { key: 'default', value: '', text: 'Select' },
  ...getStateOptions(),
]
